import { Send } from "@mui/icons-material";
import { Box, Button, OutlinedInput, Stack } from "@mui/material";
import { BaseSyntheticEvent, FC, useState } from "react";

type CommentInputProps = {
  onSubmit: (comment: string) => void;
  buttonLabel?: string;
};

export const CommentInput: FC<CommentInputProps> = ({
  onSubmit,
  buttonLabel = "Add Comments",
}) => {
  const [comment, setComment] = useState<string>("");

  const handleOnSubmit = () => {
    onSubmit(comment);
    setComment("");
  };

  return (
    <Box>
      <OutlinedInput
        value={comment}
        onChange={(e: BaseSyntheticEvent) => {
          setComment(e.target.value);
        }}
        rows={4}
        placeholder="Write a comment..."
        multiline
        fullWidth
      />
      <Stack direction={"row"} justifyContent={"flex-end"} mt={2}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<Send />}
          onClick={handleOnSubmit}
        >
          {buttonLabel}
        </Button>
      </Stack>
    </Box>
  );
};
